module.exports = __webpack_public_path__ + "static/media/sketch-preferences@2x.d5474895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/SketchPlugin/sketch-preferences@2x.png
// module id = ./src/assets/Mozilla/SketchPlugin/sketch-preferences@2x.png
// module chunks = 0